import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import TechCostList from './TechCostList';

const TechMidView = ({ techMid }) => {
    return (
        <Box sx={{ mt: 1, px: 2 }}>
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div"> 진행기록 종류</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography variant="body2" component="div">{techMid?.rptTyp}</Typography>
                    </Grid>
                </Grid>
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div">진행기록명</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography variant="body2" component="div">{techMid?.rptTitle}</Typography>
                    </Grid>
                </Grid>
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div">작업 시작일시</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="body2" component="div">{techMid?.rptStrtDt} {techMid?.rptStrtTm}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div">작업 종료일시</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="body2" component="div"> {techMid?.rptEndDt} {techMid?.rptEndTm}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div">총 작업시간</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="body2" component="div"> {techMid?.rptTotTm} 시간</Typography>
                    </Grid>
                </Grid>
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div" >진행기록 내용</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{techMid?.rptContext}</Typography>
                    </Grid>

                </Grid>
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div">실비 내역</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <TechCostList rsltCosts={techMid?.rptCostList} />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default TechMidView
